import React, { FC } from 'react';
import { LocationWithContactDto } from '@apiModels/LocationWithContactDto.csharp';

import { InfoWithBanner } from '../InfoWithBanner';
import { LocationsContactInfo } from '../LocationsContactInfo';

interface GenericAppointmentInfoProps {
  header: string;
  locations: LocationWithContactDto[];
}

export const GenericAppointmentInfo: FC<GenericAppointmentInfoProps> = (props) => {
  const { header, locations } = props;

  return (
    <div className="genericAppointmentInfo">
      <InfoWithBanner
        header={
          <h1 className="genericAppointmentInfo__header">{header}</h1>
        }
        body={
          <LocationsContactInfo<LocationWithContactDto>
            locations={locations}
            displayDropDown={false}
          />
        }
      />
    </div>
  )
};
